<template>
    <BaseLoading :loading="loading">
        <BaseRow>
            <BaseCol :col="12">
                <h6>{{ $t('settings.cash_payment_method') }}</h6>
                <BaseRadioGroup name="cash_payment_method" v-model:value="globalSettings.cash_payment_method" class="mt-1" button-style="solid">
                    <BaseRadioButton :value="obj.value" v-for="obj in STATUS_WITH_LABELS">{{ obj.label }}</BaseRadioButton>
                </BaseRadioGroup>
            </BaseCol>
            <BaseCol :col="12">
                <h6>{{ $t('settings.card_payment_method') }}</h6>
                <BaseRadioGroup name="card_payment_method" v-model:value="globalSettings.card_payment_method" class="mt-1" button-style="solid">
                    <BaseRadioButton :value="obj.value" v-for="obj in STATUS_WITH_LABELS">{{ obj.label }}</BaseRadioButton>
                </BaseRadioGroup>
            </BaseCol>

            <BaseCol :col="12">
                <h6>{{ $t('settings.withdraw') }}</h6>
                <BaseRadioGroup name="withdraw" v-model:value="globalSettings.withdraw" class="mt-1" button-style="solid">
                    <BaseRadioButton :value="obj.value" v-for="obj in STATUS_WITH_LABELS">{{ obj.label }}</BaseRadioButton>
                </BaseRadioGroup>
            </BaseCol>

            <BaseCol :col="12">
                <h6>{{ $t('settings.add_card') }}</h6>
                <BaseRadioGroup name="add_card" v-model:value="globalSettings.add_card" class="mt-1" button-style="solid">
                    <BaseRadioButton :value="obj.value" v-for="obj in STATUS_WITH_LABELS">{{ obj.label }}</BaseRadioButton>
                </BaseRadioGroup>
            </BaseCol>

            <BaseCol :col="12">
                <h6>{{ $t('settings.order_nurse') }}</h6>
                <BaseRadioGroup name="order_nurse" v-model:value="globalSettings.order_nurse" class="mt-1" button-style="solid">
                    <BaseRadioButton :value="obj.value" v-for="obj in STATUS_WITH_LABELS">{{ obj.label }}</BaseRadioButton>
                </BaseRadioGroup>
            </BaseCol>

            <BaseCol :col="12">
                <h6>{{ $t('settings.order_clinic') }}</h6>
                <BaseRadioGroup name="order_clinic" v-model:value="globalSettings.order_clinic" class="mt-1" button-style="solid">
                    <BaseRadioButton :value="obj.value" v-for="obj in STATUS_WITH_LABELS">{{ obj.label }}</BaseRadioButton>
                </BaseRadioGroup>
            </BaseCol>
            <BaseCol :col="12">
                <h6>{{ $t('table.swisslab_orders') }}</h6>
                <BaseRadioGroup name="order_swisslab" v-model:value="globalSettings.order_swisslab" class="mt-1" button-style="solid">
                    <BaseRadioButton :value="obj.value" v-for="obj in STATUS_WITH_LABELS">{{ obj.label }}</BaseRadioButton>
                </BaseRadioGroup>
            </BaseCol>

            <BaseCol :col="12">
                <h6>{{ $t('settings.order_vitros') }}</h6>
                <BaseRadioGroup name="order_vitros" v-model:value="globalSettings.order_vitros" class="mt-1" button-style="solid">
                    <BaseRadioButton :value="obj.value" v-for="obj in STATUS_WITH_LABELS">{{ obj.label }}</BaseRadioButton>
                </BaseRadioGroup>
            </BaseCol>
            <BaseCol :col="12">
                <h6>{{ $t('settings.order_psychotherapy') }}</h6>
                <BaseRadioGroup name="order_psychotherapy" v-model:value="globalSettings.order_psychotherapy" class="mt-1" button-style="solid">
                    <BaseRadioButton :value="obj.value" v-for="obj in STATUS_WITH_LABELS">{{ obj.label }}</BaseRadioButton>
                </BaseRadioGroup>
            </BaseCol>

            <BaseCol :col="12">
                <h6>{{ $t('settings.order_doctor') }}</h6>
                <BaseRadioGroup name="order_doctor" v-model:value="globalSettings.order_doctor" class="mt-1" button-style="solid">
                    <BaseRadioButton :value="obj.value" v-for="obj in STATUS_WITH_LABELS">{{ obj.label }}</BaseRadioButton>
                </BaseRadioGroup>
            </BaseCol>

            <BaseCol :col="12">
                <h6>{{ $t('settings.order_sidelka') }}</h6>
                <BaseRadioGroup name="order_sidelka" v-model:value="globalSettings.order_sidelka" class="mt-1" button-style="solid">
                    <BaseRadioButton :value="obj.value" v-for="obj in STATUS_WITH_LABELS">{{ obj.label }}</BaseRadioButton>
                </BaseRadioGroup>
            </BaseCol>

            <BaseCol :col="12">
                <h6>{{ $t('settings.order_vet') }}</h6>
                <BaseRadioGroup name="order_vet" v-model:value="globalSettings.order_vet" class="mt-1" button-style="solid">
                    <BaseRadioButton :value="obj.value" v-for="obj in STATUS_WITH_LABELS">{{ obj.label }}</BaseRadioButton>
                </BaseRadioGroup>
            </BaseCol>

            <BaseCol :col="12">
                <h6>{{ $t('settings.order_medicine') }}</h6>
                <BaseRadioGroup name="order_medicine" v-model:value="globalSettings.order_medicine" class="mt-1" button-style="solid">
                    <BaseRadioButton :value="obj.value" v-for="obj in STATUS_WITH_LABELS">{{ obj.label }}</BaseRadioButton>
                </BaseRadioGroup>
            </BaseCol>

            <BaseCol :col="12">
                <h6>{{ $t('settings.order_pharm') }}</h6>
                <BaseRadioGroup name="order_pharm" v-model:value="globalSettings.order_pharm" class="mt-1" button-style="solid">
                    <BaseRadioButton :value="obj.value" v-for="obj in STATUS_WITH_LABELS">{{ obj.label }}</BaseRadioButton>
                </BaseRadioGroup>
            </BaseCol>

            <BaseCol :col="12">
                <h6>{{ $t('settings.order_insurance') }}</h6>
                <BaseRadioGroup name="order_insurance" v-model:value="globalSettings.order_insurance" class="mt-1" button-style="solid">
                    <BaseRadioButton :value="obj.value" v-for="obj in STATUS_WITH_LABELS">{{ obj.label }}</BaseRadioButton>
                </BaseRadioGroup>
            </BaseCol>

            <BaseCol :col="12">
                <h6>{{ $t('settings.invite_friends') }}</h6>
                <BaseRadioGroup name="invite_friends" v-model:value="globalSettings.invite_friends" class="mt-1" button-style="solid">
                    <BaseRadioButton :value="obj.value" v-for="obj in TRUE_FALSE_WITH_LABELS">{{ obj.label }}</BaseRadioButton>
                </BaseRadioGroup>
            </BaseCol>

            <BaseCol justify-end class="mt-3 mb-3">
                <BaseButton @ok="save" class="btn-success">{{ $t('btns.save') }}</BaseButton>
            </BaseCol>
        </BaseRow>
    </BaseLoading>
</template>

<script setup>
    import { onMounted, reactive, ref } from 'vue';
    import BaseRadioGroup from '../custom/BaseRadioGroup.vue';
    import BaseRadioButton from '../custom/BaseRadioButton.vue';
    import { useI18n } from 'vue-i18n';
    import BaseRow from '../custom/BaseRow.vue';
    import BaseCol from '../custom/BaseCol.vue';
    import { changeSettings, getAllSettings } from '@/services/admin/settings';
    import BaseButton from '../custom/BaseButton.vue';
    import { jsonToFormData } from '@/utils/convert';
    import { showMessage } from '@/utils/toast';
    import BaseLoading from '../custom/BaseLoading.vue';

    const { t } = useI18n();
    const settingsId = ref(null);
    const loading = ref(false);

    const globalSettings = reactive({
        cash_payment_method: 0,
        card_payment_method: 0,
        withdraw: 0,
        add_card: 0,
        order_nurse: 0,
        order_clinic: 0,
        order_psychotherapy: 0,
        order_doctor: 0,
        order_sidelka: 0,
        order_vet: 0,
        order_medicine: 0,
        order_insurance: 0,
        order_pharm: 0,
        order_swisslab: 0,
        order_vitros: 0,
        invite_friends: 0,
    });

    const STATUS = Object.freeze({
        UNAVAILABLE: 0,
        INACTIVE: 1,
        ACTIVE: 2,
    });
    const TRUE_FALSE = Object.freeze({
        INACTIVE: 0,
        ACTIVE: 1,
    });
    const STATUS_WITH_LABELS = [
        { label: t('settings.unavailable'), value: STATUS.UNAVAILABLE },
        { label: t('settings.inactive'), value: STATUS.INACTIVE },
        { label: t('settings.active'), value: STATUS.ACTIVE },
    ];
    const TRUE_FALSE_WITH_LABELS = [
        { label: t('settings.inactive'), value: TRUE_FALSE.INACTIVE },
        { label: t('settings.active'), value: TRUE_FALSE.ACTIVE },
    ];

    const getAndSetSettings = () => {
        loading.value = true;
        getAllSettings()
            .then((response) => {
                settingsId.value = response.data?.id;
                Object.keys(response.data).forEach((key) => {
                    if (key == 'cash_payment_method' || key == 'card_payment_method' || key == 'invite_friends') {
                        globalSettings[key] = response.data[key] == 2 ? 2 : Boolean(response.data[key]) ? 1 : 0;
                    } else if (globalSettings.hasOwnProperty(key)) {
                        globalSettings[key] = response.data[key];
                    }
                });
            })
            .finally(() => {
                loading.value = false;
            });
    };
    onMounted(getAndSetSettings);

    const save = () => {
        const body = jsonToFormData(globalSettings);
        loading.value = true;
        changeSettings(body)
            .then(() => {
                showMessage(t('notifs.succes'));
                getAndSetSettings();
            })
            .finally(() => {
                loading.value = false;
            });
    };
</script>

<style scoped>
    h6 {
        font-size: 14px !important;
        color: grey;
    }
</style>
